"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownDivider = DropdownDivider;
exports.DropdownItem = DropdownItem;
exports.default = Dropdown;
var React = _interopRequireWildcard(require("react"));
var _Icon = _interopRequireDefault(require("./Icon"));
var _utils = require("./utils");
var _Box = require("./Box");
var _index = require("./index");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function (_e2) { function e(_x) { return _e2.apply(this, arguments); } e.toString = function () { return _e2.toString(); }; return e; }(function (e) { throw e; }), f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function (_e3) { function e(_x2) { return _e3.apply(this, arguments); } e.toString = function () { return _e3.toString(); }; return e; }(function (e) { didErr = true; err = e; }), f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
// ----- COMPONENT

function Dropdown(props) {
  var ddRef = (0, React.useRef)(null);
  var showRef = (0, React.useRef)(false);
  var _useState = (0, React.useState)(props.show),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];

  // ----- ACTION

  var position = function position(d, t) {
    var grap = props.arrowGrap || 8;
    if (props.up && props.right) return {
      left: d.left + (d.width - t.width),
      top: d.top - (t.height + grap) - window.scrollY
    };
    if (props.up) return {
      left: d.left,
      top: d.top - (t.height + grap) - window.scrollY
    };
    if (props.right) return {
      left: d.left + (d.width - t.width),
      top: d.top + d.height + grap + window.scrollY
    };
    return {
      left: d.left,
      top: d.top + d.height + grap + window.scrollY
    };
    //return { left: d.left + ((d.width - t.width) / 2), top: d.top - t.height - grap }
  };
  // ----- EVENT

  var onClickButton = function onClickButton(e) {
    return onToggle(e.currentTarget);
  };
  var onToggle = (0, _index.debounce)(function (dom) {
    if (!show && dom) onShow(dom);
    if (props.onToggle) props.onToggle(!showRef.current);
    setShow(function (p) {
      showRef.current = !p;
      return !p;
    });
  }, 100);
  var onForce = (0, _index.debounce)(function (inShow, outShow) {
    if (inShow !== outShow) {
      setShow(function () {
        showRef.current = outShow;
        return outShow;
      });
    }
  }, 100);
  var onShow = function onShow(dom) {
    var dimensions = dom.getBoundingClientRect();
    setTimeout(function () {
      if (ddRef.current) {
        var ddDimensions = ddRef.current.getBoundingClientRect();
        var pos = position(dimensions, ddDimensions);
        ddRef.current.style.top = Math.floor(pos.top) + 'px';
        ddRef.current.style.left = Math.floor(pos.left) + 'px';
        ddRef.current.style.visibility = 'visible';
      }
    }, 20);
  };
  var _clickOutside_class = function _clickOutside_class(el) {
    if (el && el.classList) {
      var ins = props.listClassClosed || ['un-dropdown-item', 'un-dropdown-item_text', 'un-dropdown-item_icon', 'un-button', '-dd-close'];
      var _iterator = _createForOfIteratorHelper(ins),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var n = _step.value;
          if (el.classList.contains(n)) return true;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return false;
  };
  var onClickOutside = function onClickOutside(e) {
    if (showRef.current && ddRef.current) {
      if (!ddRef.current.contains(e.target) || _clickOutside_class(e.target)) {
        setTimeout(function () {
          return onToggle(null);
        }, 150);
      }
    }
  };
  (0, React.useEffect)(function () {
    document.addEventListener('mousedown', onClickOutside);
    return function () {
      document.removeEventListener('mousedown', onClickOutside);
    };
  }, []);
  (0, React.useEffect)(function () {
    if (show !== undefined && props.show !== undefined) onForce(show, props.show);
  }, [show, props.show]);
  var button = (0, React.useMemo)(function () {
    if (typeof props.button === 'string') return /*#__PURE__*/React.createElement("div", {
      className: (0, _utils.clsNames)('un-dropdown-button', props.classButton),
      onClick: onClickButton
    }, props.button);
    return /*#__PURE__*/React.cloneElement(props.button, {
      onClick: onClickButton
    });
  }, [props.button]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, button, show && /*#__PURE__*/React.createElement(_Box.PortalContainer, {
    children: /*#__PURE__*/React.createElement("div", {
      ref: ddRef,
      style: {
        visibility: 'hidden'
      },
      className: (0, _utils.clsNames)('un-dropdown', props.zTop && '-top', props.className)
    }, props.children)
  }));
}
function DropdownItem(props) {
  var label = props.label,
    icon = props.icon,
    href = props.href,
    download = props.download,
    targetBlank = props.targetBlank,
    className = props.className,
    disabled = props.disabled,
    active = props.active;
  var itemProps = {
    className: (0, _utils.clsNames)('un-dropdown-item', className, disabled && '-disabled', active && '-active')
  };
  var onClick = function onClick(e) {
    e.preventDefault();
    if (props.onClick) props.onClick(e);
  };
  if (!disabled) {
    if (href) {
      itemProps.href = href;
      if (targetBlank) {
        itemProps.target = '_blank';
        itemProps.rel = 'noopener noreferrer';
      }
      if (download) itemProps.download = true;
    }
    if (props.onClick) itemProps.onClick = onClick;
    if (props.onClick) itemProps.onTouchStart = onClick;
  }
  itemProps.children = /*#__PURE__*/React.createElement(React.Fragment, null, icon && /*#__PURE__*/React.createElement(_Icon.default, {
    name: icon,
    className: "un-dropdown-item_icon",
    fixWidth: true
  }), /*#__PURE__*/React.createElement("span", {
    className: "un-dropdown-item_text"
  }, label));
  return /*#__PURE__*/React.createElement(itemProps.href ? 'a' : 'button', itemProps);
}
function DropdownDivider(props) {
  var className = props.className;
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _utils.clsNames)('dropdown-divider', className)
  });
}